import { pipeline } from "@huggingface/transformers";
import { assessTeluguPronunciation } from "./api.ts"

export async function check_audio(
  model: Blob,
  audio: Blob,
  baseWord: string
): Promise<boolean> {
  const modelUrl = URL.createObjectURL(model);
  const transcriber = await pipeline("automatic-speech-recognition", modelUrl, {
    device: "webgpu",
  });

  const audioUrl = URL.createObjectURL(audio);
  const result = await transcriber(audioUrl);
  const transcription = Array.isArray(result)
    ? String(result[0]?.text ?? "")
    : String(result?.text ?? "");
  const normalized = transcription.toLowerCase().trim();

  const similiar = normalized.includes(baseWord.toLowerCase());

  return similiar;
}

export async function check_audio_telugu(
  audio: Blob,
  baseWord: string
): Promise<boolean> {
  const result = await assessTeluguPronunciation(audio, baseWord);
  return result.passed;
}

export async function check_image(
  model: Blob,
  image: Blob,
  baseWord: string
): Promise<boolean> {
  const modelUrl = URL.createObjectURL(model);
  const imageUrl = URL.createObjectURL(image);
  const classifier = await pipeline("image-classification", modelUrl, {
    device: "webgpu",
  });
  const result = await classifier(imageUrl);

  const predictions = Array.isArray(result) ? result : [result];
  const target = baseWord.toLowerCase().trim();
  return predictions.some(
    (entry) => String(entry?.label ?? "").toLowerCase().trim() === target
  );
}
